import { getTabToken, isInternalUser } from "common/MetaActions";
import config from "config/config";
import request from "superagent";

export class FilesAPI {
  static async getFilesSummary() {
   try{
     const result = await request
      .get(config.api.files.summary())
      .set("Authorization", "Bearer " + getTabToken())
      .send();
    return result.body;
   } catch {
    return undefined
   }
  }

  static async fetchDocuments(customerId: string) {
    if (!isInternalUser()) {
      return { body: [] };
    }
    return await request
      .get(config.api.files.get(customerId))
      .set("Authorization", "Bearer " + getTabToken())
      .send();
  }

   static async updateFileWithName(
    name: string,
    fileId: string,
    customerId: string,
  ) {
    const response = await request
      .put(config.api.file.updateFileName(customerId, fileId))
      .set("Accept", "application/json")
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        newName: name,
      });

    return response;
  }
}
